<template>
  <mt-popup v-model="moduleState.chapterList" position="bottom" class="page-module">
    <div class="content-title">选择跳转章节</div>
    <div class="chapters">
      <ul>
        <li v-if="chapterList.length > 0" v-for="(chapter, $index) in chapterList" class="item elli"
            :class="{act: chapterIndex === $index}" @click="chapterSelect($index, chapter.id)">
          {{chapter.name}}
        </li>
        <li class="item elli" @click="addChapter">- 添加新章节 -</li>
      </ul>
    </div>
    <div class="btns">
      <a href="javascript:;" class="btn" @click="closeModule">取消</a>
      <a href="javascript:;" class="btn affirm" @click="chapterJump">确认</a>
    </div>
  </mt-popup>
</template>

<script>
  import Vue from 'vue';
  import {Toast} from 'mint-ui';
  import {mapState} from 'vuex';
  import store from '../store/store';
  import {GameData} from '../store/GameData';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: 'chapter_list',
    data() {
      return {
        chapterIndex:Middle.EditData.chapter,
        chapterId: Methods.getChapterVal('nowChapter').id
      }
    },
    store,
    computed: {
      ...mapState(['chapterList', 'moduleState'])
    },
    methods: {
      addChapter() {
        store.state.isAddjump = true;
        Methods.quietlySaveStory();
        Methods.addChapter(true, ComponentName.EDIT_STORY);
        Methods.checkChapterHash(27);
      },
      chapterSelect(i, id) {
        this.chapterIndex = i;
        this.chapterId = id;
        Methods.checkChapterHash(26);
      },
      closeModule() {
        Methods.cutComponent([ComponentName.CHAPTER_LIST], false);
        Methods.checkChapterHash(29);
        // this.data = this.init();
      },
      chapterJump() {
        Methods.checkChapterHash(28);
        GameData.AddEvent("event_jump", [this.chapterId]);
        this.closeModule();
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/chapter_list.css";
</style>



// WEBPACK FOOTER //
// src/components/chapter_list.vue